module.exports = __webpack_public_path__ + "static/media/headerbg_2.9b249b34.jpg";